<template>
  <b-card no-body class="shadowed h-100 p-4 mb-4">
    <small class="text-primary font-weight-bold mb-2">{{ breadcrumbs }}</small>
    <h6>{{ title }}</h6>
    <p v-if="subtitle" class="text-opacity">{{ subtitle }}</p>
    <p v-html="text" />
    <small class="text-opacity text-right mb-2"
      >{{ transChoice("journal.reflections.date") }} {{ date }}</small
    >
    <slot />
    <div class="d-flex justify-content-end">
      <b-button
        variant="outline-secondary"
        size="sm"
        class="font-weight-bold"
        @click="$emit('goToPage')"
      >
        {{ transChoice("journal.reflections.button") }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
import ServiceDetail from "../../atoms/ServiceDetail";

export default {
  components: { ServiceDetail },
  props: {
    breadcrumbs: String,
    title: String,
    subtitle: String,
    text: String,
    date: String,
  },
};
</script>
